"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("react");

var _get2 = _interopRequireDefault(require("lodash/get"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var Scrollfix =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Scrollfix, _Component);

  function Scrollfix() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, Scrollfix);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Scrollfix)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "element", {});
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "lastY", 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onWheel", function (event) {
      var deltaY = event.deltaY;

      _this.onScroll(event, deltaY);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onTouch", function (event) {
      var currentY = event.changedTouches[0].clientY;
      var deltaY = _this.lastY - currentY;

      _this.onScroll(event, deltaY);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onScroll", function (event, deltaY) {
      var scrollTop = _this.element.scrollTop;
      var touchesLength = (0, _get2["default"])(event, 'touches.length', 0);

      if (scrollTop <= 1 && deltaY < 0 && touchesLength < 2) {
        event.preventDefault();
      } else if (scrollTop + _this.element.offsetHeight >= _this.element.scrollHeight - 1 && deltaY > 0 && touchesLength < 2) {
        event.preventDefault();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getTouchStartCoord", function (event) {
      _this.lastY = event.changedTouches[0].clientY;
    });
    return _this;
  }

  (0, _createClass2["default"])(Scrollfix, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // eslint-disable-next-line react/no-find-dom-node
      this.element = _reactDom["default"].findDOMNode(this);
      this.element.addEventListener('mousewheel', this.onWheel, {
        passive: true
      });
      this.element.addEventListener('touchstart', this.getTouchStartCoord, {
        passive: true
      });
      this.element.addEventListener('touchmove', this.onTouch, {
        passive: true
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.element.removeEventListener('mousewheel', this.onWheel, {
        passive: true
      });
      this.element.removeEventListener('touchstart', this.getTouchStartCoord, {
        passive: true
      });
      this.element.removeEventListener('touchmove', this.onTouch, {
        passive: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children;
    }
  }]);
  return Scrollfix;
}(_react.Component);

(0, _defineProperty2["default"])(Scrollfix, "defaultProps", {
  freezableElement: null
});
(0, _defineProperty2["default"])(Scrollfix, "propTypes", {
  children: function children() {
    return (typeof _react.bpfrpt_proptype_Element === "function" ? _react.bpfrpt_proptype_Element.isRequired ? _react.bpfrpt_proptype_Element.isRequired : _react.bpfrpt_proptype_Element : _propTypes["default"].shape(_react.bpfrpt_proptype_Element).isRequired).apply(this, arguments);
  },
  freezableElement: _propTypes["default"].oneOf(["DEPRECATED and don`t needed anymore"])
});
var _default = Scrollfix;
exports["default"] = _default;